<template>
	<b-link :href="modal_data.url_link">
        <b-img :src="modal_data.url_image" fluid style=""></b-img>
	</b-link>
</template>
<script>
  export default {
    name: 'advertising-modal-mobile',
    props:{
        modal_data: {url_image: ""},
    },
	components: {
	},
	data(){
		return{
		}
	},
	mounted(){
	},
	methods: {
	}
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
